import Text from '@deprecated-ui/common/Text';
import Flex from '@deprecated-ui/common/Flex';
import Image from 'global/Image';
import { ButtonReload, Modal } from '../styled';

interface ModalLiveErrorProps {
  visible: boolean;
  onCancel: () => any;
  onReload: () => void;
}

function ModalLiveError({ visible, onCancel, onReload }: ModalLiveErrorProps) {
  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      centered
      footer={null}
      title={(
        <Text size="18px" family="bold" align="center">
          Unable to Load
        </Text>
        )}
      width={420}
      isResult
      destroyOnClose
      wrapClassName="livestream-modal-live-error"
      closeIcon={<Image src="/icon/close.svg" width="12" height="12" />}
    >
      <Flex align="center" padding="0 20px 10px">
        <Image width="180" height="135" src="/illustration/livestream-error-event.svg" alt="Livestream Error" />
        <Text
          // @ts-expect-error
          mt="25px"
          size="14px"
          height="19px"
          align="center"
        >
          Don&#39;t worry, we&#39;re trying to fix it. You can try again later.
        </Text>
        <ButtonReload onClick={onReload}>
          Try Again
        </ButtonReload>
      </Flex>

    </Modal>
  );
}

export default ModalLiveError;
